'use client';
import { useEffect } from 'react';
import { usePathname } from "next/navigation";

export const ScrollToTop = () => {
    const pathname = usePathname();

    useEffect(() => {
        requestAnimationFrame(() => {
            const ele = document?.getElementById('layoutContainer');
            if (ele) {
                ele.scrollTo({ top: 0, behavior: 'instant' });
            }
            window.scrollTo({ top: 0, behavior: 'instant' });
        });
    }, [pathname]);
    return null;
}